var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDraggable = function SvgDraggable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 6,
    viewBox: "0 0 22 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 0H0.875C0.640625 0 0.5 0.1875 0.5 0.375V1.125C0.5 1.35938 0.640625 1.5 0.875 1.5H21.125C21.3125 1.5 21.5 1.35938 21.5 1.125V0.375C21.5 0.1875 21.3125 0 21.125 0ZM21.125 4.5H0.875C0.640625 4.5 0.5 4.6875 0.5 4.875V5.625C0.5 5.85938 0.640625 6 0.875 6H21.125C21.3125 6 21.5 5.85938 21.5 5.625V4.875C21.5 4.6875 21.3125 4.5 21.125 4.5Z",
    fill: "#B2B2B2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDraggable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/draggable.aa28920e.svg";
export { ForwardRef as ReactComponent };